import { createUseHttpCallback } from './useHttpCallback'

export { type Callback, axiosWithRetry } from './useHttpCallback'

const usePatchCallback = createUseHttpCallback('patch', false)

export const usePatchCallbackWithRetry = createUseHttpCallback('patch', true)

export default usePatchCallback
